import { ref } from "vue";

import type { Toastable } from "@/types";

const toasts = ref<Array<Toastable>>([]);

export const useToast = () => {
	const addToast = (toast: Toastable) => {
		toasts.value.push(toast);
	};

	return {
		toasts,
		addToast,
	};
};
